import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './goblin_axe.png'

export const heaxy_axe: ItemUI<Weapon> = {
    image,
    label: 'Heavy axe',
    value: 100,
    item: {
        key: 'heaxy_axe',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            strength: 40,
            health: 40
        },
        two_handed: true,
        category: 'axe',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 4,
        damage: 15
    }
}
